/* @flow */

import * as React from 'react';
import { Switch, Route } from 'react-router-dom';

import {
  mapNotificationComponentClass,
  mapNotificationExcludePath,
  getNotificationComponentClass,
  getNotificationExcludePaths,
  isTakeOverNotification,
  isTopNotification,
  orderNotificationsByPriority,
} from 'src/shared/app/notification/util/notificationUtil';
import SecondaryNotification from 'src/shared/app/base/component/template/component/Notification';
import TakeOver from 'src/shared/app/base/component/template/component/TakeOver';
import TopNotification from 'src/shared/app/base/component/template/component/TopNotification';
import useReduxState from 'src/shared/app/base/hook/useReduxState';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

type Props = {
  queue: Array<Notification>,
};

export default ({ queue }: Props): React.Node => {
  const [notification] = orderNotificationsByPriority(queue);

  if (!notification) {
    return null;
  }

  const compClass = getNotificationComponentClass(notification);
  const excludePaths = getNotificationExcludePaths(notification);

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const state = useReduxState();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const notificationElt = React.createElement(
    mapNotificationComponentClass(compClass),
    {
      notification,
    },
  );

  const rootElt = isTakeOverNotification(notification) ? (
    <TakeOver>{notificationElt}</TakeOver>
  ) : isTopNotification(notification) ? (
    <TopNotification>{notificationElt}</TopNotification>
  ) : (
    <SecondaryNotification>{notificationElt}</SecondaryNotification>
  );

  const routesElt =
    Array.isArray(excludePaths) &&
    excludePaths
      .map((route) => mapNotificationExcludePath(route, notification, state))
      .filter(Boolean)
      .map((path) => (
        <Route path={path} exact render={() => null} key={path} />
      ));

  return routesElt ? (
    <Switch>
      {routesElt}
      <Route render={() => rootElt} />
    </Switch>
  ) : (
    rootElt
  );
};
